<template>
  <div class="width-100">
    <div v-if="!simpleButton" class="action-buy width-100">
      <input type="number" min="1" max="10000" value="1" v-model="productQuantity" :disabled="loadingAdd || disabledQtde" @change="updateQty()" />
      <button aria-label="Comprar" id="buy-button" class="btn primary-button width-100" @click="addToCart()" :disabled="loadingAdd">
        <i class="fa fa-shopping-cart"></i> COMPRAR
      </button>
    </div>

    <div v-if="simpleButton">
      <div style="display: flex; align-items: center; gap: 6px; width: 100%">
        <!-- Campo de quantidade -->
        <input
          type="number"
          min="1"
          max="10000"
          value="1"
          v-model="productQuantity"
          :disabled="loadingAdd || disabledQtde"
          @change="updateQty()"
          style="width: 60px; padding: 6px; font-size: 16px; border: 1px solid #ccc; border-radius: 4px; flex-shrink: 0"
        />

        <!-- Botão de Comprar -->
        <button
          aria-label="Comprar"
          id="buy-button"
          class="btn primary-button"
          @click="addToCart()"
          :disabled="loadingAdd"
          style="
            padding: 8px 16px;
            font-size: 14px;
            font-weight: bold;
            color: white;
            background-color: rgb(54 93 181);
            border: none;
            border-radius: 4px;
            cursor: pointer;
            flex: 1;
            min-width: 0;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          "
        >
          <i class="fa fa-shopping-cart"></i> COMPRAR
        </button>
      </div>
    </div>
    <!-- <span class="success-message" v-if="showSuccessMessage"><i class="fa fa-check"></i> Produto(s) adicionado(s) com sucesso!</span>
        <span class="error-message" v-if="showErrorMessage"><i class="fa fa-close"></i> Erro ao adicionar o produto!</span> -->

    <OrderTypeModal v-if="reload" :product="product" />
  </div>
</template>

<script>
import OrderTypeModal from './OrderTypeModal.vue'

export default {
  name: 'BuyButton',
  props: ['product', 'simpleButton'],
  data() {
    return {
      productQuantity: this.product.prdQtdeUnidade,
      loadingAdd: false,
      showSuccessMessage: false,
      showErrorMessage: false,
      reload: false,
      session: null,
      disabledQtde: false,
    }
  },
  mounted() {
    const logon = localStorage.getItem('usuarioLogado')
    if (logon) {
      this.session = JSON.parse(logon)
      if (this.session.DadosCliente.SituacaoCadastro !== 0) {
        this.disabledQtde = true
        this.productQuantity = 0
      }
    }
  },
  components: {
    OrderTypeModal,
  },
  methods: {
    updateCount() {
      this.$parent.getList()
    },
    addToCart() {
      if (this.session != null && this.session.DadosCliente.SituacaoCadastro !== 0) {
        window.location = '/cadastro/' + this.session.DadosCliente.CliCiccgc
      }

      this.loadingAdd = true
      this.showSuccessMessage = false
      this.showErrorMessage = false
      this.product.qtd = this.productQuantity
      this.reload = true
      // console.log("qtd: ", parseInt( this.product.qtd))

      this.getSession()
        .success((session) => {
          // Caso exista uma sessão
          var codigoParametro = -1
          if (session.CodigoPedido === -1 && session.CodigoOrcamento === -1) {
            // Caso não exista nenhum pedido
            $('#order-type-modal').modal('show')

            $('#order-type-modal').on('hidden.bs.modal', () => {
              this.loadingAdd = false
            })
          } else {
            if (session.CodigoPedido != -1) {
              codigoParametro = session.CodigoPedido
            } else if (session.CodigoOrcamento != -1) {
              codigoParametro = session.CodigoOrcamento
            }
            // Caso exista um pedido
            const xhr = new XMLHttpRequest()
            const data = JSON.stringify({
              codigoPedido: codigoParametro,
              prd_codigo: this.product.code.split('-')[0],
              produtoDv: this.product.code.split('-')[1],
              qtde: this.productQuantity,
            })

            xhr.open('post', this.$apiUrl + 'Carrinho.svc/AdicionarProdutoAjax')
            xhr.setRequestHeader('Content-Type', 'application/json')

            xhr.withCredentials = true

            xhr.send(data)

            xhr.onload = () => {
              this.loadingAdd = false

              if (JSON.parse(xhr.responseText)[0] == 'AVISO') {
                let span = document.createElement('span')
                span.innerHTML = JSON.parse(xhr.responseText)[1]

                swal({
                  content: span,
                  icon: 'warning',
                })
              } else {
                this.updateCount()
                swal({
                  title: 'Produto adicionado com sucesso!',
                  buttons: ['Continuar a compra', 'Ir para o carrinho'],
                }).then((goCar) => {
                  if (goCar) {
                    this.openCart()
                  }
                })
                this.showSuccessMessage = true
              }
              // console.log(JSON.parse(xhr.responseText));
            }
          }
          this.carregaDataLayer(this.product)
          // console.log(session);
        })
        .error((error) => {
          // Caso não esteja logado, joga para tela de login
          if (error.status === 401) this.$router.push('/login?redirectTo=' + window.location.href)
          else this.showErrorMessage
        })
    },
    getSession() {
      return $.ajax({
        url: this.$apiUrl + 'Session.svc/getsessions',
        dataType: 'json',
        type: 'GET',
        xhrFields: { withCredentials: true },
      })
    },
    updateQty() {
      if (this.$parent && this.$parent.updateQty)
        this.$parent.updateQty(this.productQuantity)
    },
    carregaDataLayer(value) {
      if (dataLayer) {
        dataLayer.push({ ecommerce: null })
        dataLayer.push({
          event: 'add_to_cart',
          ecommerce: {
            items: [
              {
                item_name: value.name,
                item_id: value.id,
                price: value.price,
                item_brand: value.description,
                item_qtd: value.qtd,
              },
            ],
          },
        })
      }
    },
    openCart: function () {
      const self = this
      var isVendaDireta = localStorage.getItem('GetTipoPedido').includes('DIRETA')

      if (isVendaDireta) {
        location.href = `${self.$SiteUrl}/loja/meu-carrinho-venda-direta/carrinho`
      } else {
        location.href = `${self.$SiteUrl}/loja/meu-carrinho/carrinho`
      }
    },
  },
}
</script>
